import React from "react";
import { motion } from "framer-motion";
import { 
  Code, Palette, Smartphone, Globe, Layout, 
  Search, Rocket, MessageCircle, 
  GraduationCap
} from "lucide-react";
import { Link } from "react-router-dom";
import "../styles/theme.css";

export default function Services() {
  const serviceList = [
    {
      icon: <Smartphone size={30} />,
      title: "VTU & Utility Platforms",
      desc: "Custom automated vending sites for Airtime, Data, and Bill payments with secure API integration.",
      features: ["Automated API Delivery", "Wallet Systems", "Admin Dashboards"]
    },
    {
      icon: <Layout size={30} />,
      title: "Landing Pages & Funnels",
      desc: "High-performance single-page sites designed to convert visitors for product launches or lead generation.",
      features: ["Product Showcase", "Lead Capture Forms", "Fast Loading Speed"]
    },
    {
      icon: <Code size={30} />,
      title: "Professional Portfolios",
      desc: "Modern, interactive React-based portfolios for developers and professionals with a premium look.",
      features: ["Custom Animations", "PWA (Installable)", "GitHub Integration"]
    },
    {
      icon: <Globe size={30} />,
      title: "Blog & News Hubs",
      desc: "Full-scale content platforms like Israel Creative Hub, optimized for AdSense and high traffic.",
      features: ["SEO Optimization", "JAMB/WAEC Niches", "Easy Content Management"]
    },
    {
      icon: <Palette size={30} />,
      title: "Graphic Design & Branding",
      desc: "Expert print and digital designs using CorelDRAW and Photoshop to make your brand pop locally.",
      features: ["POS & Shop Banners", "Social Media Kits", "Flyer Design"]
    },
    {
      icon: <Search size={30} />,
      title: "SEO & Mobile Performance",
      desc: "Technical optimizations to ensure your site is found on Google and runs smoothly on all devices.",
      features: ["Speed Optimization", "Schema Markup", "Technical Audits"]
    },
    {
      icon: <Rocket size={30} />,
      title: "SaaS & Web Tools",
      desc: "Developing specific web-based tools like AI summarizers or temporary email services.",
      features: ["Custom Logic", "Firebase/SQL Backend", "Interactive UI"]
    },
    {
      icon: <GraduationCap size={30} />,
      title: "Academic Digital Support",
      desc: "Setup for educational portals, result checking sites, and online resource centers.",
      features: ["School Portals", "Resource Libraries", "Exam Prep Hubs"]
    }
  ];

  return (
    <main className="page services-page">
      <section className="services-content">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="tag">My Full-Stack Expertise</div>
          <h1>Digital Solutions for Success</h1>
          <p>
            Bridging the gap between <b>security-conscious web development</b> and <b>high-visibility design</b>.
          </p>
        </motion.div>

        <div className="services-grid">
          {serviceList.map((service, index) => (
            <motion.div 
              key={index} 
              className="service-card glass"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="service-icon-box">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
              <ul className="service-features">
                {service.features.map((feat, i) => (
                  <li key={i}>{feat}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* Support/Custom Quote Section */}
        <motion.div 
          className="services-footer glass"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          <div className="footer-cta-text">
            <h2>Didn't find what you need?</h2>
            <p>I handle custom requests, technical troubleshooting, and creative consultations. Let's discuss your unique vision.</p>
          </div>
          <div className="footer-cta-action">
            <Link to="/contact" className="btn primary">
              <MessageCircle size={20} /> Ask a Question
            </Link>
            <a href="https://wa.me/2347026799440" target="_blank" rel="noreferrer" className="btn outline">
              Custom Quote
            </a>
          </div>
        </motion.div>
      </section>
    </main>
  );
}